module.exports = __webpack_public_path__ + "static/media/door_open1_icon.708a178c.png";